import React from 'react'

import './Main.css'

const Main = ({ component: Component, ...rest }) => {
  return (
    <div>
      <Component {...rest} />
    </div>
  )
}

export default Main
